import React, { forwardRef } from 'react';
import styled from 'styled-components';

import { Box } from 'Components/Base';

const StyledBox = styled(Box)`
  overflow-y: scroll;

  /* Webkit browsers (Chrome, Safari) */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Firefox */
  scrollbar-width: none;
  scrollbar-color: transparent transparent;
`;

const QuizContentWrapper = (props, ref) => {
  const { children, ...restProps } = props;
  return (
    <StyledBox ref={ref} width={1} whiteSpace="nowrap" {...restProps}>
      {children}
    </StyledBox>
  );
};

export default forwardRef(QuizContentWrapper);
